import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ReplaySubject, of } from 'rxjs';

import { catchError, switchMap } from 'rxjs/operators';

import { getCaasTranslateHeader } from '../../helpers/public-helpers';
import { HeaderConfigService } from '../../services/public-services';
import { WebFormResponse } from './caas-monday-webforms.interface';

export interface CaptchaData {
    captchaId: string | null;
    captchaImage: SafeUrl;
}
@Injectable({
    providedIn: 'root',
})
export class CaasMondayWebformsService {
    private captchaSubject = new ReplaySubject<CaptchaData>(1);
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public readonly captchaData = this.captchaSubject.asObservable();
    public constructor(
        private http: HttpClient,
        private configService: HeaderConfigService,
        private sanitizer: DomSanitizer
    ) {}

    public fetchWebFormsData(formularPath: string) {
        return this.configService.cmsProject.pipe(
            switchMap((cmsProject) => {
                const url = `/caas/direct/${cmsProject}/${formularPath}`;

                return this.http.get<WebFormResponse>(url, {
                    ...getCaasTranslateHeader(),
                });
            }),
            catchError(() => of(null))
        );
    }

    public getCaptcha(randomizedCaptchaId: number) {
        this.http
            .get(`/servlet/captcha/captcha.jpg?random.${randomizedCaptchaId}`, {
                responseType: 'blob',
                observe: 'response',
            })
            .subscribe((result) => {
                this.captchaSubject.next({
                    captchaImage: this.sanitizer.bypassSecurityTrustUrl(
                        URL.createObjectURL(result.body as Blob)
                    ),
                    captchaId: result.headers.get('mwf_jsessionid'),
                });
            });
    }
}
